import React from "react";

import { BuildingStorefrontIcon } from "@heroicons/react/24/solid";
import { useDispatch } from "react-redux";
import { TwListMoreButton, TwMoreOptions } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForEvent } from "../../utils/confighelpers";
import { TwBadge } from "../../components/tailwind/TwBadge";
import DeleteDialog from "../../components/DeleteDialog";
import { useToast } from "../../provider/ToastProvider";
import { sellerTypes } from "../../utils/constants";
import { useTranslation } from "react-i18next";

export default function SellersTile({
  setLoading,
  handleSessionClick,
  reload,
  item,
}) {
  const { t, i18n } = useTranslation();
  const { addSuccessToast } = useToast();
  const dispatch = useDispatch();
  const [userToken] = useLocalStorage("userToken");
  const [delDialogOpen, setDelDialogOpen] = React.useState(false);

  const deleteSellers = async (id) => {
    const manageClassesConfig = {
      method: "delete",
      url: `${getUrlForEvent()}seller/${id}`,
    };
    dispatch(setGlobalLoading(true));
    const responce = await axiosInstance(manageClassesConfig);
    dispatch(setGlobalLoading(false));
    if (responce.status === 200) {
    }
    reload();
  };

  return (<li className="flex items-center justify-between gap-x-6 p-5 rounded-xl hover:bg-list-hover border border-bright-gray">
    <div className="flex min-w-0 gap-x-4">
      <div className="size-12 min-w-12 flex justify-center items-center bg-black rounded-xl object-fill line-clamp-2">

        {item?.profilePic && item?.profilePic !== "" ? (<img className="size-12 rounded-xl" alt="" src={item?.profilePic} />) : (<BuildingStorefrontIcon className="size-5 fill-white" />)}
      </div>
      <div className="min-w-0 flex-auto">
        <p className="truncate text-sm/6 font-semibold text-gray-900">{item?.name}</p>
        <p className="-mt-1 truncate text-xs/5 text-gray-500 line-clamp-1">ref: {item?.sellerReferenceId || ""}</p>
        <TwBadge color="indigo" className={"capitalize text-xs"}>{sellerTypes.find((f) => f.value == item.channeltype)?.title ?? item?.channeltype ?? ""}</TwBadge>
        {/* <p className="mt-1 truncate text-xs/5 text-gray-500 line-clamp-1">{item.mobile}</p>
        <p className="mt-1 truncate text-xs/5 text-gray-500 line-clamp-1">{item.email}</p>
        <p className="mt-1 truncate text-xs/5 text-gray-500 line-clamp-1">{item?.location?.address || ""}</p> */}
      </div>
    </div>
    <div className="flex flex-none items-center gap-x-4">

      <TwMoreOptions
        options={[
          <TwListMoreButton
            className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
            onClick={() => {
              handleSessionClick();
            }}
          >
            {t("inputFieldsTitle.edit")}
          </TwListMoreButton>,
          <TwListMoreButton
            className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
            onClick={() => {
              setDelDialogOpen(true)
            }}
          >
            {t("inputFieldsTitle.delete")}
          </TwListMoreButton>,
          ...item?.connectedStripeAccount?.profileDetails
            && item?.connectedStripeAccount?.profileDetails.on_boarding_url
            && item?.connectedStripeAccount?.profileDetails.on_boarding_url !== ""
            && item?.connectedStripeAccount?.profileDetails.stripeOnBoardindStatus
            && item?.connectedStripeAccount?.profileDetails.stripeOnBoardindStatus !== "SUCCESS" ? [(<TwListMoreButton
              className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
              onClick={() => {
                navigator.clipboard.writeText(item?.connectedStripeAccount?.profileDetails.on_boarding_url);
                addSuccessToast(t("myEvents.copied"));
              }}
            >
              {t("mySellers.copyOnBordingLink")}
            </TwListMoreButton>)] : []
          ,
        ]} />
    </div>
    <DeleteDialog
      open={delDialogOpen}
      title={t("mySellers.removeSeller")}
      type={"seller"}
      handleClose={() => setDelDialogOpen(false)}
      handleDelete={() => deleteSellers(item._id)}
    />
  </li>);
}
